var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 18.3333H18.3333V7.91667L12.0833 1.66667H1.66667V18.3333ZM1.66667 20C1.2037 20 0.810185 19.838 0.486111 19.5139C0.162037 19.1898 0 18.7963 0 18.3333V1.66667C0 1.2037 0.162037 0.810185 0.486111 0.486111C0.810185 0.162037 1.2037 0 1.66667 0H12.7778L20 7.22222V18.3333C20 18.7963 19.838 19.1898 19.5139 19.5139C19.1898 19.838 18.7963 20 18.3333 20H1.66667ZM4.41667 15.25H15.5833V13.5833H4.41667V15.25ZM4.41667 10.8333H15.5833V9.16667H4.41667V10.8333ZM4.41667 6.41667H12.0833V4.75H4.41667V6.41667ZM1.66667 18.3333V1.66667V7.91667V18.3333Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailed);
export default __webpack_public_path__ + "static/media/detailed.3be459c1c55fb94e6b7a6cecf99d180b.svg";
export { ForwardRef as ReactComponent };